<template>
    <div>
      <modal-campos-nao-preenchido v-if="modalCamposNaoPreenchidos" v-model="modalCamposNaoPreenchidos" :camposNaoPreenchidos="camposNaoPreenchidos" @modalCamposNaoPreenchidoAcaoFechar="fecharModalCamposNaoPreenchidos" />
      <az-call-to-action dark
                           :active="licitacao.podePublicar"
                           :outline="!licitacao.podePublicar"
                           @click="confirmarPublicacao">
            Publicar
        </az-call-to-action>
        <az-confirm @onConfirm="efetuarPublicacao" @onDecline="esconderDialog"
                    v-if="mostrarDialog" :maxWidth=320>
            Deseja realmente efetuar a publicação?
        </az-confirm>
    </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex'
import {actionTypes, mutationTypes} from '@/commons/constants'
import validarDadosGerais from '@/views/licitacao/detalhe/orgao/licitacao-atualizacao-validar-dados-gerais'
import ModalCamposNaoPreenchido from '@/commons/components/ModalCamposNaoPreenchido.vue'

export default {
        name: 'LicitacaoAtualizacaoAcoesPublicar',
  components: {ModalCamposNaoPreenchido},
        data() {
            return {
                globalLoadingAtivado: false,
                mostrarDialog: false,
                protocolo: undefined,
                modalCamposNaoPreenchidos: false,
                camposNaoPreenchidos: []
            }
        },
        computed: {
          ehIntegracaoPrestacaoContasAtiva(){
            return this.parametros.propriedadesLicitacao.integration.integracaoSistemaDePrestacaoContasAtiva
          },
          ...mapState(['licitacao', "parametros", 'loki'])
        },
        methods: {
            async buscarProtocolo() {
              if (this.ehIntegracaoPrestacaoContasAtiva) {
                let payload = {
                  licitacaoId: this.licitacao.id,
                  operacao: "prepublicacao"
                };

                const response = await this.buscarProtocoloEsfinge(payload);
                this.protocolo = response !== "" ? response : undefined;
              }
            },
            async confirmarPublicacao() {
              const amparoValido = validarDadosGerais.validarAmparoLegal(this.licitacao)
              const comissaoValida = validarDadosGerais.validarComissao(this.licitacao)
              if (!amparoValido || !comissaoValida) {
                this.mostrarNotificacaoErro('Preencha e salve os Dados da Licitação.')
                return
              }
              await this.buscarProtocolo()
              if (this.ehIntegracaoPrestacaoContasAtiva && (this.protocolo === undefined || this.protocolo === "")) {
                this.mostrarNotificacaoErro('Publicação não pode ser realizada, é necessário primeiro realizar o envio dos dados para o E-Sfinge')
                return
              }


              this.mostrarDialog = true
            },
            desabilitarLoading() {
                if (!this.globalLoadingAtivado) {
                    this.desabilitarLoadingGlobal()
                }
            },
            async efetuarPublicacao() {
                this.esconderDialog()
                this.habilitarLoading()
                try {
                    await this.publicar()
                    await this.buscarLicitacao(this.licitacao.id)
                    this.mostrarNotificacaoSucessoDefault()
                    this.desabilitarLoading()
                } catch (e) {
                  const exception = e.response ? e.response.data : undefined

                  if (exception && exception.message === 'GATEWAY_TIMEOUT_PNCP') {
                    await this.atualizarDataTentativaPublicacaoPncp(this.licitacao.id)
                    await this.publicar()
                  }

                  if(exception && exception.errorMessages && exception.errorMessages.length > 0){
                    this.camposNaoPreenchidos = exception.errorMessages.map(error => ({mensagem: error.message}));
                    this.modalCamposNaoPreenchidos = true
                    this.mostrarNotificacaoErro("Não foi possível publicar, verifique os campos obrigatórios!")
                  }

                    this.desabilitarLoading()
                }
            },
            esconderDialog() {
                this.mostrarDialog = false
            },
            habilitarLoading() {
                this.globalLoadingAtivado = this.loki.isGlobalLoadingEnabled
                this.habilitarLoadingGlobal()
            },
            async publicar() {
                this.setMensagemLoading('Publicando...')
                await this.publicarLicitacao(this.licitacao.id)
            },
            fecharModalCamposNaoPreenchidos(){
              this.modalCamposNaoPreenchidos = false
            },
            ...mapActions([actionTypes.PUBLICAR_LICITACAO, actionTypes.BUSCAR_LICITACAO, actionTypes.BUSCAR_PROCOTOLO, actionTypes.ATUALIZAR_DATA_TENTATIVA_PUBLICACAO_PNCP]),
            ...mapMutations([mutationTypes.MOSTRAR_MENSAGEM_ERRO])
        }
    }
</script>